<template>
    <!-- 好友面板：好友列表/好友请求/添加好友 -->
    <el-dialog class="friendswrap" title="好友" :visible.sync="friendsPanelVisible"
        :before-close="friends_panel_dialog_close" append-to-body width="420px">
        <div class="friendswrap-inner" v-loading="loading">
            <div class="friend-tabs">
                <a class="friend-tab" :class="{active: activeTab == 'list'}" @click="switchTab('list')">好友<span class="tab-count">{{friends.length}}</span></a>
                <a class="friend-tab" :class="{active: activeTab == 'pending'}" @click="switchTab('pending')">请求<span class="tab-badge" v-if="pendingCount > 0">{{pendingCount}}</span></a>
                <a class="friend-tab" :class="{active: activeTab == 'add'}" @click="switchTab('add')">添加</a>
            </div>

            <!-- 好友列表 -->
            <div v-show="activeTab == 'list'">
                <div class="friend-list" v-if="friends.length > 0">
                    <div class="friend-item" v-for="friend in friends" v-bind:key="friend.id">
                        <span class="friend-name">
                            <span class="friend-nick">{{friend.friendName}}</span>
                            <TitleBadge
                                v-if="titleMap[friend.friendId]"
                                :title="titleMap[friend.friendId].title"
                                :short-title="titleMap[friend.friendId].shortTitle"
                                :tier="titleMap[friend.friendId].tier"
                                :type-name="titleMap[friend.friendId].typeName"
                                :evaluate-date="titleMap[friend.friendId].evaluateDate"
                                variant="inline"
                                ground="light"
                                :max-chars="8" />
                        </span>
                        <a class="friend-write" @click="writeTo(friend)">写信</a>
                        <a class="friend-del" @click="deleteFriend(friend)">删除</a>
                    </div>
                </div>
                <div class="noSelected" v-else>还没有好友，去「添加」页搜索用户名吧</div>
            </div>

            <!-- 收到的好友请求 -->
            <div v-show="activeTab == 'pending'">
                <div class="friend-list" v-if="pendingList.length > 0">
                    <div class="friend-item" v-for="request in pendingList" v-bind:key="request.id">
                        <span class="friend-name">{{request.userName}} <i class="request-tip">请求加你为好友</i></span>
                        <a class="friend-accept" @click="acceptRequest(request)">同意</a>
                        <a class="friend-del" @click="refuseRequest(request)">拒绝</a>
                    </div>
                </div>
                <div class="noSelected" v-else>没有待处理的好友请求</div>
            </div>

            <!-- 添加好友 -->
            <div v-show="activeTab == 'add'" class="add-box">
                <div class="add-row">
                    <el-input v-model="searchUserName" size="mini" placeholder="输入对方账号名" class="add-input"
                        @keyup.enter.native="searchUser"></el-input>
                    <el-button size="mini" @click="searchUser">查找</el-button>
                </div>
                <div class="search-result" v-if="searchResult">
                    <img class="search-avatar" v-if="searchResult.userHeader && searchResult.userHeader.headerUrl"
                        :src="ossPath + searchResult.userHeader.headerUrl">
                    <div class="search-info">
                        <div class="search-name">{{searchResult.nickName || searchResult.userName}}</div>
                        <div class="search-account">账号：{{searchResult.userName}}</div>
                    </div>
                    <a class="friend-accept" @click="addFriend">+ 加好友</a>
                </div>
                <div class="noSelected" v-if="searched && !searchResult">没有找到该用户</div>
                <div class="add-tip">添加好友需要对方确认，双方成为好友后即可互相寄信。</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getRequest, postRequest} from '../../utils/api'
import Message from 'element-ui/lib/message'
import TitleBadge from './TitleBadge'
export default {
  name: 'friendsPanel',
  components: { TitleBadge },
  props: {
    friendsPanelVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        loading: false,
        activeTab: 'list',
        friends: [],
        pendingList: [],
        pendingCount: 0,
        searchUserName: '',
        searchResult: null,
        searched: false,
        // friendId → 称号（一次批量请求取回，避免逐个好友查 N 次）
        titleMap: {}
    };
  },
  watch: {
    friendsPanelVisible: {
      handler(newVal) {
        if (newVal === true) {
          this.activeTab = 'list';
          this.searchResult = null;
          this.searched = false;
          this.loadAll();
        }
      }
    }
  },
  methods: {
    friends_panel_dialog_close() {
      this.$emit('friends_panel_dialog_close');
    },
    switchTab: function(tab) {
      this.activeTab = tab;
      if (tab == 'list' || tab == 'pending') {
        this.loadAll();
      }
    },
    loadAll: function() {
      this.loading = true;
      // 请求数角标取 list 接口返回的 pendingCount，打开面板即展示（不等点击请求页签）
      getRequest('/mail/friend/list', {}).then(resp => {
        this.loading = false;
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          this.friends = d.list || [];
          this.pendingCount = d.pendingCount || 0;
          this.loadFriendTitles();
        } else {
          Message.error(resp.data.message || '好友加载失败');
        }
      }, () => { this.loading = false; Message.error('好友加载异常'); });
      // 请求页签内容（与上面并行，互不覆盖）
      getRequest('/mail/friend/pendingList', {}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          this.pendingList = (resp.data.data || {}).list || [];
          this.pendingCount = Math.max(this.pendingCount, this.pendingList.length);
        }
      }, () => {});
    },
    /**
     * 批量取好友称号。
     * 后端一条 SQL 关联 user_ability → title → title_type，返回 userId → 称号 的映射；
     * 查不到的好友不会出现在 map 里，模板按 miss 处理为「无称号」。
     */
    loadFriendTitles: function() {
      this.titleMap = {};
      const ids = this.friends.map(f => String(f.friendId)).filter(Boolean);
      if (ids.length === 0) return;
      getRequest('/user/title/getUserTitles', { userIds: ids.join(',') }).then(resp => {
        if (resp.status == 200 && resp.data && 200 == resp.data.status) {
          this.titleMap = resp.data.data || {};
        }
      }, () => {});
    },
    deleteFriend: function(friend) {      this.$confirm('确定删除好友「' + friend.friendName + '」吗？删除后双方好友关系解除。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        appendToBody: true
      }).then(() => {
        postRequest('/mail/friend/delete', {friendUserId: friend.friendId}).then(resp => {
          if (resp.status == 200 && 200 == resp.data.status) {
            Message.success(resp.data.data || '已删除');
            this.loadAll();
          } else {
            Message.error(resp.data.message || '删除失败');
          }
        }, () => { Message.error('删除异常'); });
      }, () => {});
    },
    // 直达写信：通知宿主打开信箱写信页签并预选该好友
    writeTo: function(friend) {
      this.$emit('write-to', friend);
    },
    acceptRequest: function(request) {
      postRequest('/mail/friend/accept', {requestId: request.id}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success(resp.data.data || '已添加好友');
          this.loadAll();
        } else {
          Message.error(resp.data.message || '操作失败');
        }
      }, () => { Message.error('操作异常'); });
    },
    refuseRequest: function(request) {
      postRequest('/mail/friend/refuse', {requestId: request.id}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success('已拒绝');
          this.loadAll();
        } else {
          Message.error(resp.data.message || '操作失败');
        }
      }, () => { Message.error('操作异常'); });
    },
    searchUser: function() {
      const name = (this.searchUserName || '').trim();
      if (!name) {
        Message.warning('请输入要查找的用户名');
        return;
      }
      this.loading = true;
      getRequest('/user/user/getFantasyUserByUserName', {userName: name}).then(resp => {
        this.loading = false;
        this.searched = true;
        if (resp.status == 200 && resp.data && resp.data.id) {
          this.searchResult = resp.data;
        } else {
          this.searchResult = null;
        }
      }, () => {
        this.loading = false;
        Message.error('查询异常');
      });
    },
    addFriend: function() {
      if (!this.searchResult || !this.searchResult.id) {
        Message.warning('请先查找用户');
        return;
      }
      postRequest('/mail/friend/add', {friendUserId: this.searchResult.id}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success(resp.data.data || '好友请求已发送');
          this.loadAll();
        } else {
          Message.error(resp.data.message || '发送失败');
        }
      }, () => { Message.error('发送异常'); });
    }
  }
};
</script>

<style scoped>
.friendswrap-inner { padding: 2px 4px; }
.friend-tabs { display: flex; border-bottom: 2px solid #ebeef5; margin-bottom: 8px; }
.friend-tab { padding: 6px 14px; font-size: 14px; color: #606266; cursor: pointer; }
.friend-tab.active { color: #409eff; font-weight: bold; border-bottom: 2px solid #409eff; margin-bottom: -2px; }
.tab-count { font-size: 12px; color: #909399; margin-left: 4px; }
.tab-badge { background: #f56c6c; color: #fff; font-size: 11px; border-radius: 8px; padding: 0 5px; margin-left: 4px; }
.friend-list { max-height: 340px; overflow-y: auto; }
.friend-item { display: flex; align-items: center; gap: 8px; border-bottom: 1px solid #ebeef5; padding: 9px 4px; }
.friend-item:hover { background: #f5f7fa; }
/* 昵称与称号同行：昵称可压缩省略，称号不换行不撑行高 */
.friend-name { display: flex; align-items: center; font-size: 14px; color: #303133; flex: 1; min-width: 0; overflow: hidden; }
.friend-nick { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex-shrink: 1; }
.request-tip { font-style: normal; font-size: 12px; color: #909399; }
.friend-accept { font-size: 12px; color: #67c23a; cursor: pointer; flex-shrink: 0; }
.friend-write { font-size: 12px; color: #409eff; cursor: pointer; flex-shrink: 0; }
.friend-del { font-size: 12px; color: #f56c6c; cursor: pointer; flex-shrink: 0; }
.add-box { padding-top: 4px; }
.add-row { display: flex; gap: 8px; margin-bottom: 10px; }
.add-input { flex: 1; }
.search-result { display: flex; align-items: center; gap: 8px; padding: 8px; background: #f8f9fb; border-radius: 4px; }
.search-avatar { width: 36px; height: 36px; border-radius: 4px; }
.search-info { flex: 1; }
.search-name { font-size: 14px; color: #303133; }
.search-account { font-size: 12px; color: #909399; }
.add-tip { font-size: 12px; color: #c0c4cc; margin-top: 10px; }
.noSelected { text-align: center; color: #909399; padding: 30px 0; }
@media (max-width: 768px) {
  .friendswrap .el-dialog { width: 92% !important; margin-top: 8vh !important; }
  .friend-list { max-height: calc(60vh - 50px); }
}
</style>
